import React, { Dispatch, FC, SetStateAction } from 'react'
import styled from 'styled-components'
import { Box } from '../../../shared_components/UI/Box'
import { MethodBox } from './styles'
import Image from '../../../shared_components/Image'

const copy = `I read all ZAP documentation and understand the risk of this token purchase and can afford to lose my entire token purchase.

I am aware that this token purchase may require me to wait an extended period of time for a return

I understand ZAP does not offer token purchase advice, and I am making my own token purchase decision. As such, I am complying with my annual token purchase limit.`

const Container = styled(MethodBox)`
  margin-bottom: 0;
  p {
    margin-bottom: 1rem;
    font-family: 'Space Grotesk';
    font-style: normal;
    font-size: 14px;
    line-height: 20px;
    max-width: 556px;
    opacity: 0.6;
  }
`

const AcceptContainer = styled(Box)`
  font-family: 'Space Grotesk';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  margin-top: 24px;
  input {
    margin-right: 12px;
  }
  a {
    text-decoration: underline;
    cursor: pointer;
  }
`

const LaunchWarningBox = styled(Box)`
  background-color: rgba(255, 0, 0, 0.2);
  padding: 24px 16px;
  border-radius: 8px;

  p {
    font-family: 'Space Grotesk';
    font-size: 14px;
    opacity: 0.6;
    padding-left: 34px;
    margin: 0;
  }
`

export const WarningTitle = styled(Box)`
  font-family: 'Space Grotesk';
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
`

interface Props {
  hasAcceptedTerms: boolean
  setHasAcceptedTerms: Dispatch<SetStateAction<boolean>>
  isLaunchPool: boolean
}

const LegalStuff: FC<Props> = ({
  hasAcceptedTerms,
  setHasAcceptedTerms,
  isLaunchPool,
}) => {
  const handleChange = () => {
    setHasAcceptedTerms(!hasAcceptedTerms)
  }
  return (
    <>
      <Container>
        {copy.split('\n').map((p, i) => (
          <p key={`p-${i}`}>{p}</p>
        ))}
      </Container>
      {isLaunchPool && (
        <LaunchWarningBox dc g={8} mw="600px">
          <WarningTitle ac g={12}>
            <img src="/img/icons/chain-warning.svg" alt="warning" width={20} />
            <span>ZAP Launch</span>
          </WarningTitle>
          <p>
            Please note this is a ZAP LAUNCH Project. ZAP Launch is a
            permissionless protocol. ZAP does not endorse the projects listed on
            ZAP Launch and anyone can list. DYOR.
          </p>
        </LaunchWarningBox>
      )}
      <AcceptContainer align="center">
        <input
          type="checkbox"
          checked={hasAcceptedTerms}
          onChange={handleChange}
          id="terms-and-conditions-checkbox"
        />
        <label htmlFor="terms-and-conditions-checkbox">
          I agree to this and the{' '}
          <a
            href="https://docs.zap.tech/zaponchain/other/terms-and-conditions"
            target="_blank"
            rel="noreferrer"
          >
            Terms &amp; Conditions
          </a>
        </label>
      </AcceptContainer>
    </>
  )
}

export default LegalStuff
